import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ToggleService } from '../header/toggle.service';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { Logos } from 'src/app/core/enums/main-logo.enum';
import { sidebarMenu } from 'src/app/core/constants/sidebar-menus';
import { TranslateService } from '@ngx-translate/core';
import { SidebarMenu } from 'src/app/core/interfaces/sidebar-menu/sidebar-menu';
import { permissionEntity } from 'src/app/core/constants/permission';
import { MailBoxService } from 'src/app/core/services/mail-box/mail-box.service';
import { MailCommon } from 'src/app/core/constants/mail-box-const';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
    public panelOpenState: boolean = false;
    public nestedPanelOpenState: boolean = false;

    public isToggled: boolean = false;
    public routerUrl: { [key: string]: string } = urlRoutes;
    public mainLogo: string = Logos.mainLogo;
    public mainSidebarList: SidebarMenu[];
    isMailOpen: boolean = false;
    permissions_entity = permissionEntity;
    disc = [
        {
            mail: 'sabuj@crizac.com',
            domain: 'crizac.com',
            totalInbox: 40,
            totalArchive: 0,
            totalImportant: 1,
            totalShared: 0,
            totalJunk: 3,
            totalDrafts: 0,
            totalFolderCount: [],
        },
    ];
    fetchedDashboardCount: any = [];

    constructor(
        private toggleService: ToggleService,
        public themeService: CustomizerSettingsService,
        public translate: TranslateService,
        private _mailBoxService: MailBoxService,
        private _localStorageService: LocalStorageService,
        private _navigationService: NavigationService,
        private _authService: AuthenticationService
    ) {
        this.mainSidebarList = sidebarMenu;
    }

    ngOnInit(): void {
        this.initialSubscribers();
        this.checkForNewDashboardObject();
        // console.log(this._mailBoxService.dashboard_counts);
        // this._mailBoxService.checkDashboardCounts$
        // .subscribe((resp) => {
        //     if(Object.keys(resp).length){
        //         console.log({dashboardCount: resp});
        //         this.fetchedDashboardCount = resp;
        //     }
        // })
    }

    private initialSubscribers(): void {
        this.toggleService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
        // this.getDashboardCounts();
    }

    public toggle(): void {
        this.toggleService.toggle();
    }

    public toggleSidebarTheme(): void {
        this.themeService.toggleSidebarTheme();
    }

    public toggleHideSidebarTheme(): void {
        this.themeService.toggleHideSidebarTheme();
    }

    checkForNewDashboardObject() {
        this._mailBoxService.checkDashboardCounts$.subscribe((resp) => {
            if (resp) {
                if (Object.keys(resp).length) {
                    this.fetchedDashboardCount = resp;
                }
            }
        });
    }

    sidebarMenuChange(event: any) {
        if (event) {
            if (window.location.pathname === '/admin/mail-box') {
                if (event === 'compose') {
                    let url = `/${urlRoutes.mail_box}/${urlRoutes.compose_mail}`;
                    this._navigationService.routeToPath(url);
                }
                //   if (this.load_nested_comp) {
                //     let url = `${urlRoutes.mail_box}`;
                //     this._navigationService.routeToPath(url)
                //   }
                this._mailBoxService.mail_type = event;
                // this.search_mail_val = '';
                // this.pagination_config = {
                //   size: 50,
                //   total: 0,
                //   skip: 0,
                //   limit: 50
                // };
                // this.initialSubscribers();
                this._mailBoxService.checkFronSidebar.next(true);
            } else {
                let url = `/${urlRoutes.mainLayout}/${urlRoutes.mail_box}`;
                this._navigationService.routeToPath(url);
            }
        }
    }

    getDashboardCounts() {
        this._mailBoxService.getDashboardCounts().subscribe(
            (res) => {
                this.fetchedDashboardCount = res?.data;
                this._mailBoxService.dashboard_counts =
                    this.fetchedDashboardCount;
                if (
                    !this._localStorageService.getKey(
                        MailCommon.selected_domain
                    )
                ) {
                    this._localStorageService.setKey(
                        MailCommon.selected_domain,
                        JSON.stringify({
                            domain: this.fetchedDashboardCount[0]?.domain,
                            mail: this.fetchedDashboardCount[0]?.mail,
                        })
                    );
                    // this.initialSubscribers();
                }
            },
            (err: HttpErrorResponse) => {
                console.log(err);
            }
        );
    }

    getDashboardCountsV2(index?: number) {
        const userDetails = this._authService.getLoginUserDetails();
        if (
            userDetails &&
            userDetails?.inboxMail &&
            userDetails?.inboxMail?.length > 0
        ) {
            this._mailBoxService
                .getDashboardCountsV2(
                    userDetails?.inboxMail[0]?.mail,
                    userDetails?.inboxMail[0]?.domain
                )
                .subscribe(
                    (res) => {
                        this.fetchedDashboardCount = res?.data;
                        this._mailBoxService.dashboard_counts =
                            this.fetchedDashboardCount;
                        if (
                            !this._localStorageService.getKey(
                                MailCommon.selected_domain
                            )
                        ) {
                            this._localStorageService.setKey(
                                MailCommon.selected_domain,
                                JSON.stringify({
                                    domain: this.fetchedDashboardCount[0]
                                        ?.domain,
                                    mail: this.fetchedDashboardCount[0]?.mail,
                                })
                            );
                            // this.initialSubscribers();
                        }
                    },
                    (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                );
        }
    }

    mailCheckFromSidebar() {
        // this._mailBoxService.checkFronSidebar.subscribe({
        //     next: (res) => {
        //         if (res) {
        //             this.getDashboardCountsV2();
        //         }
        //     },
        // });
    }

    navigateToUrl(url) {
        window.open(url, '_blank');
    }

    toggleMailPanel(isOpen: boolean, index?: number): void {
        const mailPanel = this.mainSidebarList[index];
        mailPanel.isActive = isOpen;
        if (mailPanel && isOpen) {
            mailPanel.isActive = isOpen;
            if (mailPanel?.isMail) {
                if (
                    !this._localStorageService.getKey(MailCommon.selected_domain)
                ) {
                    const userDetails = this._authService.getLoginUserDetails();
                    if (
                        userDetails &&
                        userDetails?.inboxMail &&
                        userDetails?.inboxMail?.length > 0
                    ) {
                        const domains = [...new Set(userDetails?.inboxMail?.map((item) => item.domain))]?.join(',');
                        this._localStorageService.setKey(
                            MailCommon.selected_domain,
                            JSON.stringify({
                                domain: domains,
                                mail: userDetails?.inboxMail?.map((item) => item?.mail).join(',')
                            }))
                    }

                    // this.initialSubscribers();
                }

                this.isMailOpen = true;
                // this.getDashboardCountsV2(index);
            } else {
                this.isMailOpen = false;
            }
        }
    }
}
